import { useEffect, useState } from 'react';

const LoadingOverlay = () => {
    const [loadingText, setLoadingText] = useState('Loading...');

    // after 5 seconds, change the loading text to "Still loading..."

    useEffect(() => {
        setTimeout(() => {  
            setLoadingText('Still loading...');
        }, 5000);
    }, []);

    return (
        <div style={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {loadingText}
        </div>
    );
};

export default LoadingOverlay;